import { useSearchParams } from "react-router-dom";
import { appointmentUserParams } from "../enums/UserAppointmentFuturePastFilterKeys";
import { useEffect, useMemo } from "react";

export default function useUserAppointmentFilters(statusOptions) {
  const [searchParams, setSearchParams] = useSearchParams();

  const currentSort = searchParams.get(appointmentUserParams.sort) || "asc";
  const currentStatusValues = useMemo(() => {
    const statusParams = searchParams.get(appointmentUserParams.status);
    if (!statusParams) {
      return [];
    }
    const knownSet = new Set(statusOptions.map((s) => String(s.value)));

    return statusParams
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .filter((status) => {
        if (knownSet.has(String(status))) return true;
        else {
          return false;
        }
      });
  }, [searchParams, statusOptions]);

  useEffect(() => {
    const statusParam = searchParams.get(appointmentUserParams.status);
    const cleanedString =
      currentStatusValues.length > 0 ? currentStatusValues.join(" ") : null;

    if ((statusParam ?? null) === (cleanedString ?? null)) {
      return;
    }
    const p = new URLSearchParams(searchParams);
    if (cleanedString) {
      p.set(appointmentUserParams.status, cleanedString);
    } else {
      p.delete(appointmentUserParams.status);
    }
    p.set(appointmentUserParams.page, 0);
    if (p.toString() !== searchParams.toString()) {
      setSearchParams(p);
    }
  }, [currentStatusValues, searchParams, setSearchParams]);

  function handleStatusSelectChange(event) {
    const {
      target: { value },
    } = event;
    const params = new URLSearchParams(searchParams);

    const newStatusValues =
      typeof value === "string" ? value.split(" ") : value;

    if (newStatusValues.length > 0) {
      params.set(appointmentUserParams.status, newStatusValues.join(" "));
    } else {
      params.delete(appointmentUserParams.status);
    }
    params.set(appointmentUserParams.page, 0);
    setSearchParams(params);
  }

  function handleSortChange(newSortValue) {
    const params = new URLSearchParams(searchParams);
    if (newSortValue) {
      params.set(appointmentUserParams.sort, newSortValue);
    } else {
      params.delete(appointmentUserParams.sort);
    }
    params.set(appointmentUserParams.page, 0);
    setSearchParams(params);
  }

  const handleReset = () => {
    const params = new URLSearchParams(searchParams);
    for (const [key, value] of Object.entries(appointmentUserParams)) {
      params.delete(value);
    }
    setSearchParams(params);
  };
  return {
    appointmentParamKeys: appointmentUserParams,
    handleReset,
    handleSortChange,
    currentSort,
    currentStatusValues,
    handleStatusSelectChange,
  };
}
